/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { affectedSiblingSchema } from './affectedSiblingSchema';

export const membershipPreviewResponseSchema = z.object({
  get adjustedSyncedMemberships() {
    return z.array(affectedSiblingSchema);
  },
  get affectedSiblings() {
    return z.array(affectedSiblingSchema);
  },
  currentOtherTotal: z.number(),
  outcome: z.enum(['HEADROOM_USED', 'AUTO_SPLIT', 'NO_HEADROOM']),
  proposedCommitment: z.number(),
});
